import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import "./HeartIconComponent.css";
import {
  getAllWishlist,
  postWishlist,
} from "../../../features/wishlist/wishlistSlice";
import { useDispatch, useSelector } from "react-redux";

const HeartIconComponent = ({ product_id, combination_id }) => {
  const dispatch = useDispatch();
  const [favorite, setFavorite] = useState(false);
  const wishlistData = useSelector((state) => state.wishlist.allWishlist);
  useEffect(() => {
    dispatch(getAllWishlist());
  }, [dispatch]);

 

  const handleHeartClick = async (d) => {
    const data = {
      product_id: product_id,
      // combination_id:combination_id
    };
    const res = await dispatch(postWishlist(data));
    setFavorite(d);
    dispatch(getAllWishlist());
    //   const res = await addWishlist(data);
    if (res?.success) {
      // wishlistContext();
    }
  };

  return (
    // <div className='heart_icon_holder' onClick={() => setFavorite(!favorite)}>
    <div
      className="heart_icon_holder"
      onClick={() => handleHeartClick(!favorite)}
    >
      {/* <FontAwesomeIcon icon={faHeart} className={`heart_icon ${favorite ? "active" : ""}`}  /> */}
      <FontAwesomeIcon
        icon={faHeart}
        className={`heart_icon ${ wishlistData?.some((item) => item.product_id === product_id) ? "active" : ""}`}
        // className={
        //   wishlistData?.some((item) => item.product_id === product_id)
        //     ? "active"
        //     : ""
        // }
      />
    </div>
  );
};

export default HeartIconComponent;
